export default {
    firstToCreate: 'Soyez le premier à créer un fil de discussion dans ce forum',
    firstToPostInCategory: 'Soyez le premier à publier dans cette catégorie',
    firstToRespondToTopic: 'Soyez le premier à répondre à ce sujet !',
    createNewThread: 'Créer un nouveau fil',
    thread: 'fil de discussion',
    viewThread: 'Voir le fil',
    replies: 'Réponses',
    noReplies: 'Aucune réponse',
    reply: 'répondre',
    _reply: 'Répondre',
    ReplyTo: 'Répondre à',
    replyToThisQuestion: 'Répondre à cette question',
    onceRepliedModeratorMayRespond: 'Une fois que vous avez répondu, le modérateur du forum peut répondre à votre message',
    onceRepliedCanViewResponses: 'Une fois que vous avez répondu, vous pouvez voir les réponses des autres participants',
    loadingResponses: 'Chargement des réponses',
    hideXReplies: 'Masquer {count} réponses',
    showXReplies: 'Afficher {count} réponses',
    hideMostRecentReplies: 'Masquer les réponses les plus récentes',
    showMostRecentReplies: 'Afficher les réponses les plus récentes',
    post: 'Publier',
    message: 'Message',
    typeMessage: 'Saisir un message',
    addPost: 'Ajouter une publication',
    addMessage: 'Ajouter un message',
    editPost: 'Modifier la publication',
    editPostWithMedia: 'Modifier la publication avec média',
    createPostWithMedia: 'Créer une publication avec média',
    deleteMessage: 'Supprimer le message',
    deleteMessageConfirm: 'Êtes-vous sûr de vouloir supprimer ce message',
    pinPost: 'Épingler la publication',
    media: 'Média',
    uploadMedia: 'Télécharger un média',
    categories: 'catégories',
    goBack: 'Retourner',
    goBackPrevious: 'Retourner à la page précédente',
    goBackToCategory: 'Retourner à la catégorie {name}',
    loadingLatestThreads: 'Chargement des derniers fils de discussion',
    loadingDiscussionForum: 'Chargement du forum de discussion',
    dontShowAgainForTask: `Ne plus afficher pour cette tâche`,
    title: 'Titre',
    beTheFirst: 'Soyez le premier à répondre à ce fil'
};
